import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    value: 0,
  },
  reducers: {
    stateUpdate: (state, action) => {
      state.value = action.payload;
    },
    signOut: (state) => {
      state.value = 0;
    },
  },
});

// Action creators are generated for each case reducer function
export const { stateUpdate, signOut } = authSlice.actions;

export const authData = (state) => state.auth.value;

export default authSlice.reducer;
